import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { type RootState } from '~redux/rootReducer'
import { selectWorkspaceOrgs } from '~redux/slices/organizationSlice'
import { type IdentityId } from '~types'

// Intersects org ids with the selected workspace's orgs (no-op when none selected).
export const useWorkspaceScopedOrgIds = (orgIds: IdentityId[]): IdentityId[] => {
  const selectedWorkspace = useSelector(
    (state: RootState) => state?.organization.selectedWorkspace ?? null,
  )
  const workspaceOrgs = useSelector(selectWorkspaceOrgs)

  return useMemo(() => {
    if (!selectedWorkspace) return orgIds
    const workspaceOrgIds = new Set(workspaceOrgs.map((org) => org.id))
    return orgIds.filter((id) => workspaceOrgIds.has(id))
  }, [orgIds, selectedWorkspace, workspaceOrgs])
}
